// extracted by mini-css-extract-plugin
export var categoryIcon = "_cx-5";
export var connectorContainer = "_cx-1";
export var connectorLine = "_cx-0";
export var minHeight0 = "_cx-6";
export var relativeUnitValueSelector = "_cx-2";
export var trifoldSelectorBody = "_cx-4";
export var trifoldSelectorList = "_cx-3";